"use strict";
/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrashCanIcon = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var forwardRef_1 = require("../../helpers/forwardRef");
var Icon_1 = require("../../internal/Icon");
var TrashCanIcon16Light_1 = require("./TrashCanIcon16Light");
var TrashCanIcon16Regular_1 = require("./TrashCanIcon16Regular");
var TrashCanIcon16Solid_1 = require("./TrashCanIcon16Solid");
var TrashCanIcon20Light_1 = require("./TrashCanIcon20Light");
var TrashCanIcon20Regular_1 = require("./TrashCanIcon20Regular");
var TrashCanIcon20Solid_1 = require("./TrashCanIcon20Solid");
var TrashCanIcon24Regular_1 = require("./TrashCanIcon24Regular");
var TrashCanIcon24Solid_1 = require("./TrashCanIcon24Solid");
var TrashCanIcon32Regular_1 = require("./TrashCanIcon32Regular");
var TrashCanIcon64Regular_1 = require("./TrashCanIcon64Regular");
var sizes = {
    16: {
        light: TrashCanIcon16Light_1.TrashCanIcon16Light,
        regular: TrashCanIcon16Regular_1.TrashCanIcon16Regular,
        solid: TrashCanIcon16Solid_1.TrashCanIcon16Solid,
    },
    20: {
        light: TrashCanIcon20Light_1.TrashCanIcon20Light,
        regular: TrashCanIcon20Regular_1.TrashCanIcon20Regular,
        solid: TrashCanIcon20Solid_1.TrashCanIcon20Solid,
    },
    24: {
        regular: TrashCanIcon24Regular_1.TrashCanIcon24Regular,
        solid: TrashCanIcon24Solid_1.TrashCanIcon24Solid,
    },
    32: {
        regular: TrashCanIcon32Regular_1.TrashCanIcon32Regular,
    },
    64: {
        regular: TrashCanIcon64Regular_1.TrashCanIcon64Regular,
    },
};
exports.TrashCanIcon = forwardRef_1.forwardRef('TrashCanIcon', function (props, ref) {
    return react_1.default.createElement(Icon_1.Icon, tslib_1.__assign({ ref: ref }, props, { sizes: sizes }));
});
